import React, { useState } from "react";
import emailjs from "emailjs-com";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import ReCAPTCHA from "react-google-recaptcha";

const Contact = () => {
  const { register, handleSubmit, watch, errors } = useForm();
 const [captcha, setCaptcha] = useState(false)
 const [captchaData, setCaptchaData] = useState(false)
  
const serviceID = "service_0hfr39a";
const templateID = "template_wzt4csa";
const userID = "user_ZuE2BxHNDQGOJ0ya5JM21";

  const onSubmit = (data, r) => {
    if (captcha){
      sendEmail(
        serviceID,
        templateID,
        {
          name: data.name,
          phone: data.phone,
          email: data.email,
          subject: data.subject,
          description: data.description,
          captcha: data.captcha
        },
        userID
      );
      r.target.reset();
      setCaptchaData(false)
    }
    else{
      setCaptchaData('Debe chequear el captcha')
    }
    
  };

  const sendEmail = (serviceID, templateID, variables, userID) => {
    emailjs.send(serviceID, templateID, variables, userID).then(
      (result) => {
        if (result.status === 200) {
          Swal.fire({
            icon: "success",
            title: "Contacto",
            text: "Se ha enviado su mensaje a Rafael Martínez",
          });
        }
      },
      (error) => {
        Swal.fire({
          icon: "error",
          title: "Ups!",
          text: "Hubo un problema al enviar el mensaje a Rafael Martínez",
        });
        console.log(error.text);
      }
    );
  };

  return (
    <div className="contacts bg-dark" id="contact">
      <h1 className="text-center text-uppercase colorTexto">Contacto</h1>
      <p className="text-center">
        Puede contactarse con mi persona, llenando el formulario y este me enviará un correo electrónico. 
      </p>

      <div className="container">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col-md-6 col-xs-12">
              <div className="text-center">
                <input
                  className="form-control"
                  placeholder="Asunto"
                  name="subject"
                  type="text"
                  id="asunto"
                  autoComplete="off"
                  ref={register({
                    required: "Ingrese un asunto",
                  })}
                />

                <div className="line"></div>
              </div>
              <span className="error-message mb-5 text-danger">
                {errors.subject && errors.subject.message}
              </span>
              {/* NAME INPUES */}
              <div className="text-center">
                <input
                  className="form-control"
                  placeholder="Nombre y Apellido"
                  name="name"
                  type="text"
                  id="nombre"
                  autoComplete="off"
                  ref={register({
                    required: "Ingrese un nombre y/o apellido",
                    maxLength: {
                      value: 20,
                      message: "Escriba menos de 20 caracteres",
                    },
                  })}
                />
                <div className="lineBoton"></div>
              </div>
              <span className="error-message mb-2 text-danger">
                {errors.name && errors.name.message}
              </span>
              {/* NAME INPUES */}
              <div className="text-center">
                <input
                  className="form-control"
                  placeholder="Teléfono"
                  name="phone"
                  type="number"
                  id="phone"
                  autoComplete="off"
                  ref={register({
                    required: "Ingese un número de teléfono",
                    maxLength: {
                      value: 8,
                      message: "Escriba máximo 8 caracteres",
                    },
                  })}
                />
                <div className="line"></div>
                
              </div>
              <span className="error-message mb-2 text-danger">
                {errors.phone && errors.phone.message}
              </span>
              {/* NAME INPUES */}
              <div className="text-center">
                <input
                  className="form-control"
                  placeholder="Email"
                  name="email"
                  type="email"
                  id="email"
                  autoComplete="off"
                  ref={register({
                    required: "Ingrese un email",
                    maxLength: {
                      value: 50,
                      message: "Escriba menos de 50 caracteres",
                    },
                  })}
                />
                <div className="line"></div>
              </div>
              
              <span className="error-message mb-2 text-white">
                Por favor utilizar su correo electrónico real, pues recibirá un correo de confirmación.
              </span><br></br>
              <span className="error-message mb-2 text-danger">
                {errors.email && errors.email.message}
              </span>
              
            </div>

            <div className="col-md-6 col-xs-12">
              <div className="text-center">
                <textarea
                  className="form-control"
                  placeholder="Descripción"
                  name="description"
                  type="text"
                  id="descripcion"
                  ref={register({
                    required: "Ingrese una descripción",
                    minLength: {
                      value: 10,
                      message: "Escriba más de 10 caracteres",
                    },
                  })}
                ></textarea>
                <div className="line"></div>
              </div>
              <span className="error-message mb-2 text-danger">
                {errors.description && errors.description.message}
              </span>
                <ReCAPTCHA
                  sitekey="6LdA69waAAAAAKihvuJzKCoe21UZ7Qz2Tv7Hysa9"
                  onChange={()=>setCaptcha(true)}
                />
                <span className="error-message mb-2 text-danger">
                {captchaData && captchaData}
                </span>
                <button type="submit" className="mt-2 btn btn-primary boton">
                Enviar
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Contact;
